<template>
  <div class="tvl_layer tvl_layer_account">
      <div class="tvl_bd">
          <div class="tvl_account">
              <div class="tvl_account_tit" :class="{tvl_account_nochange:!showSwitch}"><span class="tvl_name">确认领取到{{userInfo.type === 'wx' ? '微信' : 'QQ'}}帐号:{{userInfo.nick}}</span>
                <a v-if="showSwitch" class="tvl_change" @click="swithLogin">切换账号</a>
              </div>
              <div class="tvl_account_avater">
                  <div class="tvl_avater">
                      <img class="tvl_avater_img" :src="userInfo.headurl || defaultAvatar">
                  </div>
              </div>
          </div>
          <div class="tvl_btn tvl_btn_2">
              <a class="tvl_btn_a" @click="close">取     消</a>
              <a class="tvl_btn_b" @click="ok">确     认</a>
          </div>
      </div>
  </div>
</template>

<script>
import env from '@tencent/vft-common/env'
import cookie from '@tencent/vft-common/cookie'
export default {
  data () {
    return {

    }
  },
  methods: {
    swithLogin () {
      cookie.set('givemovie_take', '1', {
        domain: location.host,
        path: '/'
      })
      this.$emit('close')
      return this.$openLogin()
    },
    close () {
      this.$emit('close')
    },
    ok () {
      this.$emit('close')
      this.$emit('ok')
    }
  },
  computed: {
    showSwitch () {
      return !env.isApp && !env.isMqq && navigator.userAgent.indexOf('Qzone') === -1
    }
  }
}
</script>
